import React, { useState, useEffect } from "react";
import defaultBackground from "../../Images/background.svg";
import SaveIcon from "../../Images/SaveIcons.svg";
import stylePoster from "./Poster.module.scss";
import Pen from "../../Images/Pen.svg";
import CloseIconWhite from "../../Images/VectorWhite.svg";


interface PosterProps {
  setFormData: React.Dispatch<React.SetStateAction<any>>;
  hasError?: boolean; // Добавляем пропс для ошибки
}

interface PosterProps {
  editableCover?: string | null;
  editablePhotos?: string[] | null;
  setFormData: React.Dispatch<React.SetStateAction<any>>;
}
interface EventPhoto {
  id: number;
  src: string | ArrayBuffer;
}

export const Poster: React.FC<PosterProps> = ({ editableCover, editablePhotos, setFormData, hasError }) => {
  // Установка изображений по умолчанию (если событие только создается) или получение изображений в случае редактирования
  const initialEventPhotos = (editablePhotos ? editablePhotos.map((src, index) => (
    { id: index, src })) : []);
  const initialBackground = editableCover ? editableCover : defaultBackground;
  const initialMargin = editablePhotos ? (editablePhotos.length > 1 ? "264px" : "134px") : "0px";

  const [background, setBackground] = useState<string | ArrayBuffer | null>(initialBackground);
  const [eventPhotos, setEventPhotos] = useState<EventPhoto[]>(initialEventPhotos);
  const [isSmallScreen, setIsSmallScreen] = useState(false);
  const [specialMargin, setSpecialMargin] = useState(initialMargin); // Для управления отступами

  useEffect(() => {
    setFormData((prev: any) => ({
      ...prev,
      cover: background,
      photos: eventPhotos.map((photo) => photo.src),
    }));
  }, [background, eventPhotos, setFormData]);

  useEffect(() => {
    const mediaQuery = window.matchMedia("(max-width: 435px)");
    const handleMediaQueryChange = (e: MediaQueryListEvent) => {
      setIsSmallScreen(e.matches);
    };

    mediaQuery.addEventListener("change", handleMediaQueryChange);
    setIsSmallScreen(mediaQuery.matches);

    return () => {
      mediaQuery.removeEventListener("change", handleMediaQueryChange);
    };
  }, []);

  // Функция загрузки обложки
  const handleImageUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        setBackground(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  // Функция загрузки фотографий события
  const handleEventPhotoUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file && eventPhotos.length < 5) {
      const reader = new FileReader();
      reader.onload = () => {
        setEventPhotos((prevPhotos) => {
          const updatedPhotos = [
            ...prevPhotos,
            { id: prevPhotos.length + 1, src: reader.result as string | ArrayBuffer },
          ];

          if (updatedPhotos.length === 1) {
            setSpecialMargin("134px");
          }
          if (updatedPhotos.length === 2) {
            setSpecialMargin("264px");
          }

          return updatedPhotos;
        });
      };
      reader.readAsDataURL(file);
    }
  };

  // Функция удаления фотографии с пересчетом индексов
  const removeEventPhoto = (id: number) => {
    setEventPhotos((prevPhotos) => {
      const updatedPhotos = prevPhotos
        .filter((photo) => photo.id !== id)
        .map((photo, index) => ({
          ...photo,
          id: index + 1, // Переназначение индексов для корректного отображения
        }));

      // Если фотографии закончились, сбрасываем отступы
      if (updatedPhotos.length === 0) {
        setSpecialMargin("0px");
      }
      if (updatedPhotos.length === 1) {
        setSpecialMargin("134px");
      }

      return updatedPhotos;
    });
  };


  let photosContainerClass = "";
  switch (eventPhotos.length) {
    case 1:
      photosContainerClass = stylePoster.onePhoto;
      break;
    case 2:
      photosContainerClass = stylePoster.twoPhotos;
      break;
    case 3:
      photosContainerClass = stylePoster.threePhotos;
      break;
    case 4:
      photosContainerClass = stylePoster.fourPhotos;
      break;
    case 5:
      photosContainerClass = stylePoster.fivePhotos;
      break;
    default:
      photosContainerClass = "";
  }

  return (
    <div
      className={stylePoster.leftColumn}
      style={{ marginBottom: specialMargin }} // Применяем стиль
    >
      <div className={stylePoster.uploadSection}>
        <div
          className={stylePoster.coverImage}
          style={{ backgroundImage: `url(${background})` }}
        >
          {background === defaultBackground && (
            <span className={stylePoster.labelText}>Обложка афиши</span>
          )}
          <input
            type="file"
            accept="image/*"
            className={stylePoster.uploadInput}
            onChange={handleImageUpload}
            id="upload-button"
          />
          <label htmlFor="upload-button" className={stylePoster.uploadButton}>
            {background === defaultBackground ? (
              "Загрузить +"
            ) : (
              <>
                Изменить <img src={Pen} alt="pen" className={stylePoster.penImage} />
              </>
            )}
          </label>
        </div>
        {hasError && background === defaultBackground && (
          <p className={stylePoster.errorText}>Добавьте фото обложки</p>
        )}
        <input
          type="file"
          accept="image/*"
          className={stylePoster.uploadInput}
          onChange={handleEventPhotoUpload}
          id="event-photo-upload-button"
        />
        <div className={`${stylePoster.eventPhotosContainer} ${photosContainerClass}`}>
          {eventPhotos.map((photo) => (
            <div
              key={photo.id}
              className={`${stylePoster.eventPhoto} ${stylePoster[`p${photo.id}`]}`}
              style={{ backgroundImage: `url(${photo.src})` }}
            >
              <img
                src={CloseIconWhite}
                alt={"close icon"}
                className={stylePoster.closeIcon}
                onClick={() => removeEventPhoto(photo.id)}
              />
            </div>
          ))}
        </div>
        <div className={stylePoster.containerButtonUpload}>
          <label htmlFor="event-photo-upload-button" className={`${stylePoster.photoButton} ${eventPhotos.length >= 5 ? stylePoster.disabledButton : ''}`} >
            {isSmallScreen
              ? `Фото ${eventPhotos.length}/5`
              : `Добавить фото ${eventPhotos.length}/5`}{" "}
            <img src={SaveIcon} alt={"icon"} className={stylePoster.saveIcon} />
          </label>

          {hasError && eventPhotos.length === 0 && (
            <p className={stylePoster.errorText}>Добавьте фото</p>
          )}
        </div>
      </div>
    </div>
  );
};








